<template>
    <div dusk="ThemeMode" class="flex gap-2">
        <button
            v-for="option in ui.themeOptions"
            :key="option.value"
            :dusk="option.value"
            :class="[
                'flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border-2 transition-colors duration-150',
                isSelected(option.value)
                    ? 'border-theme-accent bg-theme-accent-bg text-theme-accent high-contrast-dark:border-[3px]'
                    : 'border-transparent bg-transparent text-theme-toolbar-icon hover:bg-black/[0.04] high-contrast-dark:hover:bg-white/[0.08] dark:hover:bg-white/[0.06]',
            ]"
            :title="getOptionLabel(option.value)"
            :aria-label="getOptionLabel(option.value)"
            :aria-pressed="String(isSelected(option.value))"
            @click="changeTheme(option.value)"
        >
            <!-- System icon -->
            <svg
                v-if="option.value === 'system'"
                aria-hidden="true"
                width="22"
                height="22"
                viewBox="0 0 32 32"
                fill="none"
            >
                <circle cx="16" cy="16" r="14" stroke="currentColor" stroke-width="2" />
                <path d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14V2z" fill="currentColor" />
            </svg>

            <!-- Light icon -->
            <svg
                v-else-if="option.value === 'light'"
                aria-hidden="true"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
            >
                <circle cx="12" cy="12" r="4" fill="currentColor" />
                <path
                    d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                />
            </svg>

            <!-- Dark icon -->
            <svg
                v-else-if="option.value === 'dark'"
                aria-hidden="true"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    :fill="isSelected('dark') ? 'currentColor' : 'none'"
                />
            </svg>
        </button>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'ThemeSelector',
    props: {
        showTitle: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['changed-theme'],
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
    },
    methods: {
        ...mapActions(['setTheme', 'saveUserSettings']),
        changeTheme(theme) {
            this.setTheme({ theme });
            this.saveUserSettings({ theme });
            this.$emit('changed-theme');
        },
        isSelected(theme) {
            return this.ui.theme === theme;
        },
        getOptionLabel(value) {
            const labelKeys = {
                system: 'themeSystem',
                light: 'themeLight',
                dark: 'themeDark',
            };
            return this.localizations[this.lang][labelKeys[value]] || value;
        },
    },
};
</script>
